// Свежесть показаний метеостанции. «Сейчас» в карточке маршрута показываем
// только для показаний не старше окна (по умолчанию 90 минут): станция могла
// перестать присылать данные, а устаревшая погода на горном маршруте - это
// вводящая в заблуждение подсказка о безопасности.
export const FRESH_READING_MS = 90 * 60 * 1000;

export const isFreshReading = (polledAt: string | null | undefined, nowMs: number, maxMs = FRESH_READING_MS): boolean => {
  if (!polledAt) return false;
  const t = new Date(polledAt).getTime();
  return Number.isFinite(t) && nowMs - t <= maxMs;
};

export const isSameLocalDay = (iso: string, nowMs: number): boolean => {
  const a = new Date(iso);
  const b = new Date(nowMs);
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
